import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectIsAcknowledgedValue = createSelector(
  [selectComposedReportState],
  ({ isAcknowledged }) => isAcknowledged
)
